module.exports = __webpack_public_path__ + "static/media/tie_fighter_by_radiusss.207f39eb.svg";